import React from 'react'
import { CustomDialogContent } from '..'
import { createStyles, makeStyles, Typography, Theme } from '@material-ui/core'

interface IHowToUseTheAppModal {
  onCloseInfoModal: () => void
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    contentContainer: {
      lineHeight: 2,
      textAlign: 'justify',
      margin: theme.spacing(2, 0),
    },
    strong: {
      fontWeight: 'bold',
    },
  })
)

export const HowToUseTheAppModal = ({ onCloseInfoModal }: IHowToUseTheAppModal) => {
  const classes = useStyles()
  return (
    <CustomDialogContent title="How to use the app?" onCancel={onCloseInfoModal}>
      {/* <Typography variant="h5" className={classes.contentContainer}>
        Sign Up
      </Typography>
      <Typography variant="body1" className={classes.contentContainer}>
        The daily dose app is accessible from any device connected to the internet.
        Make sure you have a network connection and a mobile or PC and access the app
        using this link from anywhere.
      </Typography>
      <Typography variant="body1" className={classes.contentContainer}>
        {`Once you hae accessed the app, you will need to Sign Up and create a user. Here's
        how:`}
      </Typography>
      <Typography variant="body1" className={classes.contentContainer}>
        1. Create an account using your email and choose a password. Alternatively
        you can login with your Google or Facebook account.
      </Typography>
      <Typography variant="body1" className={classes.contentContainer}>
        {`2. Select a username and that's it.`}
      </Typography> */}
      {/* <Typography variant="h6" className={classes.contentContainer}>
        First Steps
      </Typography> */}
      <Typography variant="body1" className={classes.contentContainer}>
        Once you have logged in, you will be able to browse through the app.
      </Typography>
      <Typography variant="body1" className={classes.contentContainer}>
        Home Page: From here you will be able to see the dose of the days of the
        group you are part of. Also you will see the group list and profile detail.
      </Typography>
      <Typography variant="body1" className={classes.contentContainer}>
        1. <span className={classes.strong}>{`Looking for fun?:`}</span> Here you
        will see a list of suggested doses you add to your groups
      </Typography>
      <Typography variant="body1" className={classes.contentContainer}>
        2. <span className={classes.strong}>{`Add group: `}</span> From here you can
        add more groups to your list.
      </Typography>
      <Typography variant="body1" className={classes.contentContainer}>
        3. <span className={classes.strong}>{`Groups: `}</span> You will see the list
        of groups you are part of and their quick access menu.
      </Typography>
      <Typography variant="body1" className={classes.contentContainer}>
        4. <span className={classes.strong}>{`Menu bar: `}</span>Use it to quick
        access Home, Profile Menu.
      </Typography>

      <Typography variant="body1" className={classes.contentContainer}>
        5. <span className={classes.strong}>Add a dose: </span>Click on the plus +
        sign to add a dose to any group
      </Typography>
    </CustomDialogContent>
  )
}
